export const name = 'topologyService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-topology' as const
